import { Radio } from "shared/components";
import { type RegisterTyped } from "shared/hooks/use-form-typed";
import { cx } from "shared/utils";
import { SyncOption, SyncOptionLabels } from "../../constants";

const SYNC_OPTIONS = [
  SyncOption.NEVER,
  SyncOption.FIRST_SYNC,
  SyncOption.EVERY_SYNC
];

interface Props {
  field: ReturnType<RegisterTyped<Record<string, string>>>;
  prose: React.ReactNode;
  bordered?: boolean;
}

export const SyncOptionRadioGroup = ({ field, prose, bordered }: Props) => (
  <div
    className={cx(
      "flex flex-col gap-2",
      bordered && "border-t border-alpha-40 pt-4"
    )}
  >
    <p className="text-sm font-medium text-content-700">{prose}</p>
    <div className="flex flex-col gap-2">
      {SYNC_OPTIONS.map((option) => (
        <Radio
          key={option}
          id={`${field.name}-${option}`}
          name={field.name}
          value={option}
          checked={field.value === option}
          onChange={field.onChange}
          label={SyncOptionLabels[option]}
          className="text-sm"
        />
      ))}
    </div>
    {field.error && <p className="text-xs text-error-500">{field.error}</p>}
  </div>
);
